export const mapServiceSlugToPath = (slug?: string) => {
  if (!slug) return "";
  if (slug === "casos-de-exito") return "casos-de-exito";
  if (slug === "sistemas-aislados") return "instalaciones-fotovoltaicas-aisladas";
  return slug;
};

export const getServicePath = (slug?: string) => `/${mapServiceSlugToPath(slug)}`;
